import React from 'react';
import { UserReward } from '../../Types/UserReward';
import RewardCard, { RewardCardRarity } from '../RewardCard';

interface UniverseCreationRewardProps {
  reward: UserReward;
}

const UniverseCreationReward: React.FC<UniverseCreationRewardProps> = ({
  reward,
}) => {
  const universeContent = (
    <div className="w-20 h-20 rounded-full bg-gray-50 border border-gray-200 flex items-center justify-center mb-2 overflow-hidden">
      <img
        src={require('../../assets/icons/universe.svg')}
        alt=""
        className="w-full h-full object-cover"
      />
    </div>
  );

  return (
    <RewardCard
      reward={reward}
      title="Universe Token"
      description="Use this to bring any universe you can dream of to life when creating a book"
      rarity={RewardCardRarity.Epic}
      content={universeContent}
      type="Universe"
    />
  );
};

export default UniverseCreationReward;
